import React from 'react';
import { observer } from 'mobx-react';
import { useIntl } from 'react-intl';
import { ModulesVM } from '../modules.viewmodel';
import { ModuleRow } from '../_module-row/module-row';
import { HubModuleVM } from '../hub-module.viewmodel';
import CollapseSection from '../../../../../../../global/collapse-section/collapse-section';
import { MODULES_INACTIVE_SECTION_LABEL_TEXT } from '../../../../../../event-hubs.text';
import './inactive-modules-section.scss';

type InactiveModulesSectionProps = {
    vm: ModulesVM;
    canManage: boolean;
};

export const InactiveModulesSection: React.FC<InactiveModulesSectionProps> = observer(({ vm, canManage }) => {
    const intl = useIntl();

    const renderModuleRow = (moduleVM: HubModuleVM): JSX.Element => (
        <ModuleRow
            key={moduleVM.getClientId()}
            vm={moduleVM}
            onEdit={vm.openEditModuleModal}
            onToggleActive={vm.toggleModuleActive}
            onRemove={vm.removeModule}
            editingDisabled={!canManage}
        />
    );

    if (vm.inactiveModules.length === 0) {
        return null;
    }

    return (
        <div className='inactive-modules-section'>
            <CollapseSection title={intl.formatMessage(MODULES_INACTIVE_SECTION_LABEL_TEXT)} isDefaultCollapsed>
                {vm.inactiveModules.map(renderModuleRow)}
            </CollapseSection>
        </div>
    );
});
